(ns quuppa.peweb.tables
  (:require [re-frame.core :as rf]
            [komponentit.scrollbar-width :as scrollbar]
            [quuppa.ui.button :as button]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.layout :as layout]
            [quuppa.peweb.peinfo-events :as e]))

(defn width-fn [table-width total-width col-width]
  (/ (* table-width (or col-width 5.0)) total-width))

(rf/reg-event-db
  ::toggle-column
  (fn [db [_ qpe-identity k default-columns column on-off]]
    (if on-off
      (update-in db [:qpes qpe-identity :ui k] (fnil conj default-columns) column)
      (update-in db [:qpes qpe-identity :ui k] (fnil disj default-columns) column))))

(rf/reg-event-db
  ::reset-columns
  (fn [db [_ qpe-identity k]]
    (update-in db [:qpes qpe-identity :ui] dissoc k)))

(defn columns-sidebar [{:keys [qpe-subscribe qpe-dispatch]}
                       {:keys [k default-columns all-columns max-selections]}]
  (let [selected-columns (or @(qpe-subscribe [:qpe/data :ui k])
                             default-columns)]
    [layout/sidebar
     [:div.d-flex.flex-column.border-bottom
      [:div.sidebar-header
       [:h3.sidebar-header-title "Show/hide columns"]
       [button/close-button
        {:class "p-3 d-none d-md-block"
         ;; On desktop, close button keeps the changes
         :on-click #(qpe-dispatch [::e/apply-panel-changes k])}]
       ;; On mobile, close button cancels the changes
       [button/close-button
        {:class "p-3 d-block d-md-none"
         :on-click #(qpe-dispatch [::e/cancel-panel-changes k])}]]

      [:div.sidebar-header-tools
       [:button.btn.btn-link.px-0.text-decoration-none
        {:on-click #(qpe-dispatch [::reset-columns k])}
        "Reset to default"]
       (when max-selections
         [:span
          "Selected " (count selected-columns) " of " max-selections])]]

     [:div.sidebar-content.sidebar-content--scroll
      [:div.select-list
       (for [[column {:keys [label always-selected selectable]}] all-columns
             :when (not (false? selectable))]
         [:label.user-select-none
          {:key column}
          [:input {:type      "checkbox"
                   :checked   (contains? selected-columns column)
                   :disabled  (or always-selected
                                  (and (not (contains? selected-columns column))
                                       (some? max-selections)
                                       (>= (count selected-columns) max-selections)))
                   :on-change #(qpe-dispatch [::toggle-column k default-columns column (.. % -target -checked)])}]
          [:span.pl-3 label]])]]

     [:div.sidebar-actions
      [:button.btn.btn-outline-primary.btn-lg
       {:on-click #(qpe-dispatch [::e/cancel-panel-changes k])}
       "Cancel"]
      [:button.btn.btn-primary.btn-lg.ml-3
       {:on-click #(qpe-dispatch [::e/apply-panel-changes k])}
       "Apply"]]]))

(defn table-header [{:keys [bounds all-columns selected-columns sort-by-field sort-order-asc selected-columns-width]}]
  [scrollbar/scrollbar-padding {}
   [:div.d-flex.flex-row.w-100.div-table-row
    (for [[column {:keys [sortable width label]}] all-columns
          :when (contains? selected-columns column)]
      [:div.bg-dark.text-white.p-1.d-flex.flex-row.align-items-center.div-table-cell.cursor-pointer
       {:key   column
        :style {:width (width-fn (.-width bounds) selected-columns-width width)}
        :on-click (when sortable
                    (fn [_e]
                      (rf/dispatch [:nav/update-query assoc
                                    :sort-field column
                                    :sort-asc (if (= column sort-by-field)
                                                (not sort-order-asc)
                                                true)])))}
       (when sortable
         [icon (if (= sort-by-field column)
                 (if sort-order-asc
                   :sort-down
                   :sort-up)
                 :sort-down)
          {:class ["mr-2"
                   "flex-shrink-0"
                   (when-not (= sort-by-field column)
                     "text-muted ")]}])
       label])]])

(def query-params
  [:map
   [:sort-field {:optional true} :keyword]
   [:sort-asc {:optional true} :boolean]
   [:panel {:optional true} :keyword]])

(defn thead [{:keys [columns sort-key sort-order-asc set-sort-key toggle-sort-order]}]
  [:thead
   [:tr
    (doall
      (for [[column {:keys [sortable width label]}] columns]
        [:th.cursor-pointer.user-select-none
         {:key column
          :style {:width width}
          :on-click (when sortable
                      (fn [_e]
                        (if (= sort-key column)
                          (toggle-sort-order)
                          (set-sort-key column))))}
         [:div.d-flex.flex-row.align-items-center
          (when sortable
            [icon (if (= sort-key column)
                    (if sort-order-asc
                      :sort-down
                      :sort-up)
                    :sort-down)
             {:class ["mr-2"
                      (when-not (= sort-key column)
                        "text-muted ")]}])
          label]]))]])
